export default __webpack_public_path__ + "static/capability-terminal-KZ-cfd3594751046e2064a1af12f7ffc1e2.png";